import { Paper } from '@mui/material';
import useAuthz from 'hooks/useAuthz';
import React from 'react';
import { useNavigate } from 'react-router';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const css = {
  label: { fontSize: '1.35vw' },
};

const ModuleAdmin = (props) => {
  const { libelle, fontAwesomePicture, disabled, url } = props;
  const navigate = useNavigate();
  const [authz, user, profil] = useAuthz();

  const handleOnClick = (url) => {
    if (profil.profil === 1 && !disabled) {
      navigate(url);
    }
  };

  return (
    <Paper className={(disabled || profil.profil === 2) ? 'module-admin-disabled' : 'module-admin'} onClick={() => handleOnClick(url)}>
      {typeof fontAwesomePicture === 'string' && <i className={fontAwesomePicture} style={{ marginRight: '20px', fontSize: '35px' }} />}
      {typeof fontAwesomePicture === 'object' && <FontAwesomeIcon icon={fontAwesomePicture} style={{ height: '35px', margin: '0 20px' }} />}
      <p style={css.label}>{libelle}</p>
    </Paper>
  );
};

export default ModuleAdmin;
